@import '~style-sheet-helpers/core.less';
@import '../../../constants/spacing.module.less';

.body {
  gap: @space-12;
}

.loading-indicator {
  height: 100%;
  width: 100%;
  min-height: 300px;
  > * {
    min-height: 300px;
  }
}

.red {
  color: @red-650;
}

.content {
  gap: @space-16;
}

.information-section {
  gap: @space-20;
  padding: @space-12;
  background: var(--grey-200);
  font-weight: 700;
}

.service-and-price,
.row {
  justify-content: space-between;
  align-items: center;
}

.you-spent {
  margin-right: @space-4;
}

.fancy-row {
  border-radius: 5px;
  border: 2px solid transparent;
  border-image-slice: 1;
  background-image:
    linear-gradient(to right, var(--white), var(--white)),
    linear-gradient(to right, var(--blue-93CCFD), var(--purple-B085FF), var(--red-F1C1C1));
  background-origin: border-box;
  background-clip: content-box, border-box;
  margin-bottom: @space-8;
}

.fancy-row-content {
  justify-content: space-between;
  align-items: center;
  padding: @space-8;
}

.big-number {
  font-size: 24px;
}

.disclaimer {
  font-size: 14px;
  color: @grey-700;
  font-weight: 400;
}

.service-display {
  align-items: center;
  margin-right: @space-12;

  > img {
    height: 20px;
    width: 20px;
    object-fit: contain;
    margin-right: @space-4;
  }
}

.center-text {
  text-align: center;
}

.shipment-data-header {
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.collapsible-header {
  svg {
    fill: var(--blue-600);
  }
}

.chevron-text {
  color: var(--blue-600);
}
